import { UnitLeader } from './unit-leader.model';
import { StakePosition } from './stake-position.enum';
import { Address } from '../util/address.model';

export class StakeLeader extends UnitLeader {
  positionType: StakePosition;
  campusStakeId: number;
  campusStakeOfficeId: number;

  constructor(positionType?: StakePosition, campusStakeId?: number) {
    super();

    this.positionType = positionType;
    this.campusStakeId = campusStakeId;
    this.address = new Address();

    if (positionType) {
      switch (positionType) {
        case StakePosition.President:
          this.position = 'President';
          break;
        case StakePosition.FirstCounselor:
          this.position = '1st Counselor';
          break;
        case StakePosition.SecondCounselor:
          this.position = '2nd Counselor';
          break;
      }
    }
  }
}
